module.exports = __webpack_public_path__ + "assets/oslp-alt.b4dca3b4.svg";